export interface ISaveUser {
  id: number;
  brokerCode?: string;
  company?: string;
  userName: string;
  userEmail: string;
  userPhoneNo: string;
  userNIN: string;
  userBirthDt?: string;
  defaultDashboard: string;
  userGroup: EUserGroup;
  userMenu: string;
  restrictedAccess: boolean;

  allowTermWf: boolean;
  allowAccessApiKeys?: boolean;
  userPassword?: string;
  firstName: string;
  lastName: string;
  userRoleType: EUserRole;
  loginUrl?: string;

  userStatus: string;
  jobRole?: string;
  directSupervisor?: string;
  reliefOfficer?: string;

  fullName?: string;
  userBirthDay?: string;
  lastCommendationDate?: string;
  staffNo?: string;
  branchCode?: string;
  department?: string;
  licenseCat?: ELicensesCat;
  licenseCode?: string;
}
export interface IUser extends ISaveUser {
  createdOn: string;
  updatedOn: string;
  createdBy: string;
  updatedBy: string;
  fullName: string;
}

export enum ELicensesCat {
  company = 'U',
  broker = 'B',
  lossAdjuster = 'L',
}

export enum EUserRole {
  user = 'USER',
  superAdmin = 'SUPER_ADMIN',
}

export enum EUserType {
  superAdmin = 'SUPER_ADMIN',
  admin = 'NAICOM',
  ciin = 'CIIN',
  bpp = 'BPP',
  cifm = 'CIFM',
  nia = 'NIA',
  broker = 'BROKER',
  company = 'COMPANY',
  lossAdjuster = 'LOSS_ADJUSTER',
  candidate = 'CANDIDATE',
  arian = 'ARIAN',
}

export enum EUserGroup {
  naicom = 'NAICOM',
  ciin = 'CIIN',
  bpp = 'BPP',
  cifm = 'CIFM',
  nia = 'NIA',
  compliance = 'COMPLIANCE',
  agentAdmin = 'AGENT_ADMIN',
  finance = 'FINANCE',
  informationTechnology = 'INFORMATION TECHNOLOGY',
  arian = 'ARIAN',
}


export const UserTypeMapping: Record<EUserType, { label?: string, }> = {
  [EUserType.superAdmin]: { label: 'Super admin' },
  [EUserType.admin]: { label: 'Admin' },
  [EUserType.ciin]: { label: 'Ciin' },
  [EUserType.bpp]: { label: 'Bpp' },
  [EUserType.cifm]: { label: 'Cifm' },
  [EUserType.nia]: { label: 'Nia' },
  [EUserType.broker]: { label: 'Broker' },
  [EUserType.company]: { label: 'Company' },
  [EUserType.lossAdjuster]: { label: 'Loss adjuster' },
  [EUserType.candidate]: { label: 'Candidate' },
  [EUserType.arian]: { label: 'Arian' },
}


export const UserGroupMapping: Record<EUserGroup, { userType?: EUserType }> = {
  [EUserGroup.naicom]: {},
  [EUserGroup.nia]: { userType: EUserType.nia },
  [EUserGroup.ciin]: { userType: EUserType.ciin },
  [EUserGroup.bpp]: { userType: EUserType.bpp },
  [EUserGroup.cifm]: { userType: EUserType.cifm },
  [EUserGroup.arian]: { userType: EUserType.arian },
  [EUserGroup.informationTechnology]: { userType: EUserType.company },
  [EUserGroup.finance]: { userType: EUserType.company },
  [EUserGroup.agentAdmin]: { userType: EUserType.company },
  [EUserGroup.compliance]: { userType: EUserType.company },
}

interface RootObject {
  company: string;
  userName: string;
  userEmail: string;
  userPhoneNo: string;
  userNIN: string;
  userGroup: string;
  userMenu: string;
  restrictedAccess: boolean;
  allowTermWf: boolean;
  defaultDashboard: string;
  userPassword: string;
  firstName: string;
  lastName: string;
  userRoleType: string;
  loginUrl: string;
}
